import { createApp } from "vue";
import { traduit } from "./composant/b2bLangue";
import html from "./sessionExpired.html";
import { Echangeur } from "../Echangeur";

const js = ({
	url: function () {

	},
	onLoad: function (echangeur) {
		let THIS = this;
		const session = echangeur.hash.session;
		const app = createApp({
			data: function () {
				return {
					username: session.username,
					failLogin: false,
					showPassword: false,

					passwordReset: false,
					afterPasswordReset: false,
					alertEmailSent: false,

					errorEmail: false,
					errorPassword: false,

					email: null,
					password: null,

					successLogin: false
				}
			},
			methods: {

				resetErrorAndAlert: function () {
					this.errorPassword = false;
					this.afterPasswordReset = false;
					this.failLogin = false;
					this.successLogin = false;
				},

				async sessionExpiredForm(e) {
					this.resetErrorAndAlert()
					e.preventDefault();

					if (!this.password) {
						this.errorPassword = true
					} else {
						var echangeur = new Echangeur();
						echangeur.addAction("sessionInit", {}, "", 'session');
						echangeur.loginInfo = { username: this.username, password: this.password }
						const x = await echangeur.runAsync({ nomodal: true }); //on verifie si on est authentifié
						//
						this.password = null;

						if (x.erreur) {
							this.failLogin = true;
						} else {
							THIS.fin();
						}
					}
					/*
					if (this.password && this.failLogin == false) {
						this.successLogin = true;
						this.email = null;
						this.password = null;
						//
						THIS.fin();
					} */
				},

				fin: function () {
					THIS.fin();
				},

				t(value) {
					return traduit(value, "session");
				},
			}
		});

		app.mount(THIS.c$('._vueChargement')[0]);

	}

});

export default {
	sessionExpired: { js: js, html: html }
};

